package com.flowyride.data.account

actual fun platformTokenStore(): TokenStore = InMemoryTokenStore()

actual val platformUsesSessionCookie: Boolean = true
